import { Action } from "@ngrx/store";
import { IServerResponse } from "app/interface";
import {
    GOVERNANCE_LIST, GET_GOVERNANCE_LIST, SEARCH_GOVERNANCE_BY_ID, GOVERNANCE_BY_ID,
    ADD_GOVERNANCE, ADD_GOVERNANCE_RESPONSE, UPDATE_GOVERNANCE, UPDATE_GOVERNANCE_RESPONSE,
    DELETE_GOVERNANCE, DELETE_GOVERNANCE_RESPONSE, SEARCH_GOVERNANCE_BY_FIELD, GOVERNANCE_BY_FIELD_LIST,
    VALIDATE_START_DATE, VALIDATE_START_DATE_RESP
} from "./actionTypes";

export class GetGovernanceList implements Action {
    readonly type = GET_GOVERNANCE_LIST;
}

export class GovernanceList implements Action {
    readonly type = GOVERNANCE_LIST;
    readonly payload = []
    constructor(governanceList: Array<any>) {
        this.payload = governanceList;
    }
}

export class SearchGovernanceById implements Action {
    readonly type = SEARCH_GOVERNANCE_BY_ID;
    readonly payload: string = null;
    constructor(id) {
        this.payload = id
    }
}

export class SearchGovernanceByField implements Action {
    readonly type = SEARCH_GOVERNANCE_BY_FIELD;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class GovernanceByFieldList implements Action {
    readonly type = GOVERNANCE_BY_FIELD_LIST;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}
export class GovernanceById implements Action {
    readonly type = GOVERNANCE_BY_ID;
    readonly payload = null;
    constructor(data) {
        this.payload = data
    }
}

export class AddGovernance implements Action {
    readonly type = ADD_GOVERNANCE;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class AddGovernanceResponse implements Action {
    readonly type = ADD_GOVERNANCE_RESPONSE;
    readonly payload: IServerResponse = null;
    constructor(resp) {
        this.payload = resp;
    }
}

export class UpdateGovernance implements Action {
    readonly type = UPDATE_GOVERNANCE;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class UpdateGovernanceResponse implements Action {
    readonly type = UPDATE_GOVERNANCE_RESPONSE;
    readonly payload: IServerResponse = null;
    constructor(resp) {
        this.payload = resp;
    }
}

export class DeleteGovernance implements Action {
    readonly type = DELETE_GOVERNANCE;
    readonly payload = null;
    constructor(id: string) {
        this.payload = id;
    }
}

export class DeleteGovernanceResponse implements Action {
    readonly type = DELETE_GOVERNANCE_RESPONSE;
    readonly payload: IServerResponse = null;
    constructor(resp) {
        this.payload = resp;
    }
}

export class ValidateStartDate implements Action {
    readonly type = VALIDATE_START_DATE;
    readonly payload: any;
    constructor(data) {
        this.payload = data;
    }
}

export class ValidateStartDateResp implements Action {
    readonly type = VALIDATE_START_DATE_RESP;
    readonly payload: any;
    constructor(data) {
        this.payload = data;
    }
}

export type Actions = GetGovernanceList | GovernanceList | SearchGovernanceById | GovernanceById |
    AddGovernance | AddGovernanceResponse | UpdateGovernance | UpdateGovernanceResponse | DeleteGovernance
    | DeleteGovernanceResponse | SearchGovernanceByField | GovernanceByFieldList | ValidateStartDate | ValidateStartDateResp;
